import { apiClient } from "@finitless/shared/lib";

/**
 * Hook for business gallery operations
 */
export const useBusinessGallery = () => {
  const handleAddBusinessGallery = async (businessId, galleryData) => {
    try {
      const response = await apiClient.post(
        `/business/${businessId}/gallery`,
        galleryData,
      );
      return response;
    } catch (error) {
      console.error("Error adding to business gallery:", error);
      throw error;
    }
  };

  return {
    handleAddBusinessGallery,
  };
};

export default useBusinessGallery;
